export default __webpack_public_path__ + "static/media/rainbow.a87a138b.svg";